export enum BoardEditorLoadState {
    Idle,
    Saving,
    Error,
}
